import React from 'react';
import PropTypes from 'prop-types';
import Spinner from '@99designs/react-components/components/Spinner';
import OnsiteNotificationsListItem from './onsite-notifications-list-item';
import OnsiteNotificationsScrollable from './onsite-notifications-scrollable';
import { FormattedMessage } from "react-intl";

export default class OnsiteNotificationsList extends React.Component {
    constructor(props) {
        super(props);

        this.handleMarkAllRead = this.handleMarkAllRead.bind(this);
    }

    handleMarkAllRead(e) {
        e.preventDefault();
        this.props.onMarkAllRead();
    }

    notifications() {
        const notifications = this.props.notifications;

        if (this.props.isLoading) {
            return (
                <div className="onsite-notifications__spinner">
                    <Spinner />
                </div>
            );
        }

        if (notifications.length === 0) {
            return (
                <div className="onsite-notifications__message-none">
                    <FormattedMessage id="No notifications found." defaultMessage="No notifications found." />
                </div>
            );
        }

        return (
            <OnsiteNotificationsScrollable
                viewportHeightDiff={this.props.viewportHeightDiff}
            >
                {
                    Object.keys(notifications)
                        .map((key) => {
                            return (
                                <OnsiteNotificationsListItem
                                    key={key}
                                    notification={notifications[key]}
                                />
                            );
                        })
                }
            </OnsiteNotificationsScrollable>
        );
    }

    render() {
        return (
            <div
                className="onsite-notifications__list"
            >
                <div className="onsite-notifications__header">
                    <div className="onsite-notifications__header__heading">
                        <FormattedMessage id="Notifications" defaultMessage="Notifications" />
                    </div>
                </div>
                { this.notifications() }
                <div className="onsite-notifications__footer">
                    <div className="onsite-notifications__footer__see-all">
                        <a
                            href={this.props.urls.notifications}
                            className="onsite-notifications__link"
                        >
                            <FormattedMessage id="See all notifications" defaultMessage="See all notifications" />
                        </a>
                    </div>
                    <a
                        href="#"
                        className="onsite-notifications__link onsite-notifications__footer__mark-read"
                        onClick={this.handleMarkAllRead}
                    >
                        <FormattedMessage id="Mark all as read" defaultMessage="Mark all as read" />
                    </a>
                </div>
            </div>
        );
    }
}

OnsiteNotificationsList.propTypes = {
    notifications: PropTypes.array.isRequired,
    urls: PropTypes.object.isRequired,
    onMarkAllRead: PropTypes.func,
    viewportHeightDiff: PropTypes.number,
    isLoading: PropTypes.bool,
}

OnsiteNotificationsList.defaultProps = {
    onMarkAllRead() {},
    isLoading: true,
}



// WEBPACK FOOTER //
// ./~/@99designs/globalnav/src/components/onsite-notifications-list.jsx